import { forwardRef } from 'react'
import { HandlerOf } from 'shared/helpers/typeHelper'

import { TextInputProps } from '../TextInput/TextInput'
import { AddressDropdown, AddressDropdownBlueStyledLocationIcon } from './AddressDropdown'
import { SearchDropdownProps } from './SearchDropdown'

export interface LocationDropdownProps
  extends Omit<SearchDropdownProps, 'options' | 'width' | 'maxHeight' | 'onChange' | 'value'> {
  width?: number
  maxHeight?: number
  value?: string | null
  onChange?: HandlerOf<string>
  inputProps?: TextInputProps
  enableRawValues?: boolean
}

export const LocationDropdown = forwardRef(function LocationDropdown(props: LocationDropdownProps, ref: any) {
  function renderOption(label: string) {
    return (
      <>
        <AddressDropdownBlueStyledLocationIcon />
        {label}
      </>
    )
  }

  return (
    <AddressDropdown
      {...props}
      ref={ref}
      searchTypes="(cities)"
      renderOption={renderOption}
      inputProps={{
        endAdornment: null,
        ...props.inputProps,
      }}
    />
  )
})
